import { jsx } from "react/jsx-runtime";
import { createSvgIcon } from "@mui/material";
const Clock = createSvgIcon(
  /* @__PURE__ */ jsx("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.50016 1C6.13216 1 5.8335 1.29867 5.8335 1.66667C5.8335 2.03467 6.13216 2.33333 6.50016 2.33333H9.16683C9.53483 2.33333 9.8335 2.03467 9.8335 1.66667C9.8335 1.29867 9.53483 1 9.16683 1H6.50016ZM12.4963 2.47005C12.3263 2.48397 12.1608 2.56376 12.0418 2.70443C11.8038 2.98509 11.8393 3.40586 12.12 3.64453L13.0692 4.44922C13.3498 4.68722 13.7706 4.65176 14.0093 4.37109C14.2473 4.09043 14.2118 3.66966 13.9312 3.43099L12.9819 2.6263C12.8416 2.5073 12.6663 2.45614 12.4963 2.47005ZM7.8335 3C4.5255 3 1.8335 5.692 1.8335 9C1.8335 12.308 4.5255 15 7.8335 15C11.1415 15 13.8335 12.308 13.8335 9C13.8335 5.692 11.1415 3 7.8335 3ZM7.8335 5C8.2015 5 8.50016 5.29867 8.50016 5.66667V9C8.50016 9.368 8.2015 9.66667 7.8335 9.66667C7.4655 9.66667 7.16683 9.368 7.16683 9V5.66667C7.16683 5.29867 7.4655 5 7.8335 5Z",
      fill: "currentColor"
    }
  ) }),
  "Clock"
);
export {
  Clock
};
